import React from 'react'
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import toast from 'react-hot-toast';
import { baseURL } from 'utils/api';
import { useLocation, useNavigate } from 'react-router-dom';

const Reset = ({ email, setShow }) => {

  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  const navigate = useNavigate();
  const { pathname } = useLocation();


  const HandleReset = () => {

    if (password == confirmPassword) {
      fetch(`${baseURL}reset/password?type=${pathname=='/forgotInstitute'?'Institute':'Teacher'}&phoneOrEmail=${email}&newPassword=${password}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((resp) => {
          if (resp.success) {
            navigate('/login')
            return toast.success(resp?.message);
          }
          if (!resp.success) {
            return toast.error(resp.error || resp?.message);
          }
        })
        .catch((err) => {
          return toast.error(err.message);
        });
    }
    else {
      return toast.error('Password and Confirm Password does not match')

    }

  }

  return (
    <div>
      <SoftBox mb={2}>
        <SoftBox mb={1} ml={0.5}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            Password
          </SoftTypography>
        </SoftBox>
        <SoftInput
          onChange={(e) => setPassword(e.target.value)}
          type="password" placeholder="Password" />
      </SoftBox>
      <SoftBox mb={2}>
        <SoftBox mb={1} ml={0.5}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            Confirm Password
          </SoftTypography>
        </SoftBox>
        <SoftInput
          onChange={(e) => setConfirmPassword(e.target.value)}
          type="password" placeholder="Confirm Password" />
      </SoftBox>
      <SoftBox mt={4} mb={1}>
        <SoftButton
          onClick={HandleReset}
          variant="gradient" color="info" fullWidth>
          Reset
        </SoftButton>
      </SoftBox>

    </div>
  )
}

export default Reset